module.exports = __webpack_public_path__ + "img/transparent-logo.6f2bbbcb.png";